import React, { useState, useEffect } from 'react';
import ApiRequestService from '../component/ApiRequestService';

const ExcludedAOPreview = ({ selectedSubcategoryKeys = [] }) => {
    const [subcategoryNames, setSubcategoryNames] = useState([]);

    const keysStr = [...selectedSubcategoryKeys].sort().join(',');

    useEffect(() => {
        if (!keysStr) { setSubcategoryNames([]); return; }

        const parsed = keysStr.split(',').map(key => {
            const [subject_id, topic_id, category_id, subcategory_id] = key.split('_').map(Number);
            return { key, subject_id, topic_id, category_id, subcategory_id };
        });

        const byCategory = {};
        parsed.forEach(p => {
            const ck = `${p.subject_id}_${p.topic_id}_${p.category_id}`;
            if (!byCategory[ck]) byCategory[ck] = { ...p, items: [] };
            byCategory[ck].items.push(p);
        });

        Promise.all(
            Object.values(byCategory).map(async (group) => {
                const subRes = await ApiRequestService({
                    method: 'post', url: '/getAllSubCategories',
                    data: { subject_id: group.subject_id, topic_id: group.topic_id, category_id: group.category_id },
                });

                const subcategories = subRes?.data?.data?.subCategory_names || [];
                const selectedIds = new Set(group.items.map(i => String(i.subcategory_id)));

                return subcategories
                    .filter(sc => selectedIds.has(String(sc.subcategory_id)))
                    .map(sc => ({
                        key: group.items.find(i => String(i.subcategory_id) === String(sc.subcategory_id)).key,
                        name: sc.subcategory_name,
                    }));
            })
        ).then(results => setSubcategoryNames(results.flat()));
    }, [keysStr]);

    if (subcategoryNames.length === 0) return null;

    return (
        <div style={{ marginTop: 8 }}>
            {subcategoryNames.map((sc, idx) => (
                <div
                    key={sc.key}
                    style={{
                        boxShadow: '0px 1px 6px rgba(0,0,0,0.08)',
                        borderRadius: '8px',
                        minHeight: '30px',
                        padding: '8px 12px',
                        marginBottom: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        background: '#fff',
                    }}
                >
                    <input
                        type="radio"
                        disabled
                        style={{ marginRight: 10, width: 16, height: 16 }}
                    />
                    <span style={{ fontSize: 14 }}>{sc.name}</span>
                </div>
            ))}
        </div>
    );
};

export default ExcludedAOPreview;
